export const jobtypeConstants = {
    LOGIN_REQUEST: 'JOBTYPES_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'JOBTYPES_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'JOBTYPES_LOGIN_FAILURE',

    LOGOUT: 'JOBTYPES_LOGOUT',

    GETALL_REQUEST: 'JOBTYPES_GETALL_REQUEST',
    GETALL_SUCCESS: 'JOBTYPES_GETALL_SUCCESS',
    GETALL_FAILURE: 'JOBTYPES_GETALL_FAILURE',


    
    GETALL_JOBTYPE_NOTIFY_REQUEST: 'GETALL_JOBTYPE_NOTIFY_REQUEST',
    GETALL_JOBTYPE_NOTIFY_SUCCESS: 'GETALL_JOBTYPE_NOTIFY_SUCCESS',
    GETALL_JOBTYPE_NOTIFY_FAILURE: 'GETALL_JOBTYPE_NOTIFY_FAILURE',

    UPDATE_JOBTYPE_NOTIFY_REQUEST: 'UPDATE_JOBTYPE_NOTIFY_REQUEST',
    UPDATE_JOBTYPE_NOTIFY_SUCCESS: 'UPDATE_JOBTYPE_NOTIFY_SUCCESS',
    UPDATE_JOBTYPE_NOTIFY_FAILURE: 'UPDATE_JOBTYPE_NOTIFY_FAILURE',


    ADD_RESTAURANT_JOBTYPE_REQUEST: 'ADD_RESTAURANT_JOBTYPE_REQUEST',
    ADD_RESTAURANT_JOBTYPE_SUCCESS: 'ADD_RESTAURANT_JOBTYPE_SUCCESS',
    ADD_RESTAURANT_JOBTYPE_FAILURE: 'ADD_RESTAURANT_JOBTYPE_FAILURE',

    FILE_UPLOAD_STATUS_REQUEST: 'FILE_UPLOAD_STATUS_REQUEST',
    FILE_UPLOAD_STATUS_SUCCESS: 'FILE_UPLOAD_STATUS_SUCCESS',
    FILE_UPLOAD_STATUS_FAILURE: 'FILE_UPLOAD_STATUS_FAILURE',


    GET_RESTAURANT_REQUEST: 'GET_RESTAURANT_REQUEST',
    GET_RESTAURANT_SUCCESS: 'GET_RESTAURANT_SUCCESS',
    GET_RESTAURANT_FAILURE: 'GET_RESTAURANT_FAILURE',
    
    ADD_MENU_REQUEST: 'ADD_MENU_REQUEST',
    ADD_MENU_SUCCESS: 'ADD_MENU_SUCCESS',
    ADD_MENU_FAILURE: 'ADD_MENU_FAILURE',


    ADD_ITEM_REQUEST: 'ADD_ITEM_REQUEST',
    ADD_ITEM_SUCCESS: 'ADD_ITEM_SUCCESS',
    ADD_ITEM_FAILURE: 'ADD_ITEM_FAILURE',

    DEL_ITEM_REQUEST: 'DEL_ITEM_REQUEST',
    DEL_ITEM_SUCCESS: 'DEL_ITEM_SUCCESS',
    DEL_ITEM_FAILURE: 'DEL_ITEM_FAILURE',

    UPDATE_CATEGORY_REQUEST: 'UPDATE_CATEGORY_REQUEST',
    UPDATE_CATEGORY_SUCCESS: 'UPDATE_CATEGORY_SUCCESS',
    UPDATE_CATEGORY_FAILURE: 'UPDATE_CATEGORY_FAILURE',

    UPDATE_ITEM_REQUEST: 'UPDATE_ITEM_REQUEST',
    UPDATE_ITEM_SUCCESS: 'UPDATE_ITEM_SUCCESS',
    UPDATE_ITEM_FAILURE: 'UPDATE_ITEM_FAILURE',


    STATS_REQUEST: 'STATS_REQUEST',
    STATS_SUCCESS: 'STATS_SUCCESS',
    STATS_FAILURE: 'STATS_FAILURE',

};
